// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_2kxLy","batchTable":"List_batchTable_33r20","detail":"List_detail_rU6E5"};